import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import "./index.css";

// Remove pre-rendered content used for crawlers/SEO once JS mounts
const preNode = document.getElementById("ssg-pre");
if (preNode) {
  preNode.remove();
}

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
